
import { i18nText } from '@/locales';
import Vue from 'vue';
import Component from 'vue-class-component';
import { ITableColumn } from '@/entity/table/table.types';

@Component
export class AccountHistoryTableMix extends Vue {
    get columns(): ITableColumn[] {
        return [
            {
                title: i18nText("Тип операции"),
                dataIndex: 'peration_type_id',
                key: 'peration_type_id',
                scopedSlots: {
                    customRender: 'TypeOperationColumn',
                },
            },
            {
                title: i18nText("Дата и время"),
                dataIndex: 'updated_at',
                key: 'updated_at',
                scopedSlots: {
                    customRender: 'AccountDate'
                }
            },
            {
                title: i18nText("Автор"),
                dataIndex: 'author.name',
                key: 'author.name',
                scopedSlots: {
                    customRender: 'Author'
                }
            },
            {
                title: i18nText("Студия"),
                dataIndex: 'salon.name',
                key: 'salon.name',
            },
            {
                title: i18nText("Сотрудник"),
                dataIndex: 'staff.name',
                key: 'staff.name',
            },
            {
                title: i18nText("Сумма"),
                dataIndex: 'amount',
                key: 'amount',
            },
            {
                title: i18nText("Остаток"),
                dataIndex: 'balance',
                key: 'balance',
            },
        ];
    }
}
